// extracted by mini-css-extract-plugin
export default {"signInContainer":"signIn_signInContainer__dZX6Q","buttonsContainer":"signIn_buttonsContainer__-gTyx"};